"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Modal = void 0;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _icons = require("@cian/ui-kit-design-tokens/icons");
var _Controls = require("../../../PromoModal/parts/Controls");
var _ModalCustomOverlay = require("../../../../common/ModalCustomOverlay");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Modal = props => {
  const {
    children,
    open,
    onClose,
    controls
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    desktop: true,
    tablet: true
  }, /*#__PURE__*/React.createElement(_uiKit.ModalRoot, {
    open: open,
    onOpenChange: onClose
  }, /*#__PURE__*/React.createElement(_uiKit.ModalContent, {
    size: "M",
    overlay: "transparent"
  }, /*#__PURE__*/React.createElement(_ModalCustomOverlay.ModalCustomOverlay, null), /*#__PURE__*/React.createElement(_uiKit.ModalCloseButton, {
    title: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C",
    size: "XS",
    theme: "fill_light",
    icon: /*#__PURE__*/React.createElement(_icons.IconActionClose16, null),
    tabIndex: -1
  }), /*#__PURE__*/React.createElement(_uiKit.ModalBody, null, children), /*#__PURE__*/React.createElement(_uiKit.ModalFooter, {
    sticky: true
  }, /*#__PURE__*/React.createElement(_Controls.Controls, null, controls))))), /*#__PURE__*/React.createElement(_uiKit.Responsive, {
    phone: true
  }, /*#__PURE__*/React.createElement(_uiKit.ModalFullscreen, {
    open: open,
    onClose: onClose,
    theme: "white"
  }, children)));
};
exports.Modal = Modal;